angular.module('impactx.profile').controller('AddressPreferencesDialogCtrl', ['$mdDialog', 'addressField', 'translations', AddressPreferencesDialogController]);

function AddressPreferencesDialogController($mdDialog, addressField, translations) {
    this.possibleAddressFields = addressField.addressFields;
    this.selectedAddressFields = addressField.selected;
    this.searchText = '';
    this.selectedItem = null;
    this.trns = translations;

    this.apply = function() {
        $mdDialog.hide({possible: this.possibleAddressFields, selected: this.selectedAddressFields});
    };

    this.close = function() {
        $mdDialog.cancel();
    };

    this.addSelectedItem = function() {
        var itemIndex;
        if(this.selectedItem) {
            //Add..
            itemIndex = this.selectedAddressFields.indexOf(this.selectedItem);
            if(itemIndex < 0) {
                this.selectedAddressFields.push(this.selectedItem);
            }
            //Remove..
            itemIndex = this.possibleAddressFields.indexOf(this.selectedItem);
            if(itemIndex > -1) {
                this.possibleAddressFields.splice(itemIndex, 1);
            }
            this.searchText = '';
        }
    };

    this.removeItem = function(item) {
        if(item) {
            this.possibleAddressFields.push(item);
            var indexToRemove = this.selectedAddressFields.indexOf(item);
            if(indexToRemove > -1 && this.selectedAddressFields.length > 1) {
                this.selectedAddressFields.splice(indexToRemove, 1);
            }
        }
    };

    this.moveItemToFirstPosition = function(item) {
        if(item) {
            var index = this.selectedAddressFields.indexOf(item);
            if(index > -1) {
                this.selectedAddressFields.move(index, 0)
            }
        }
    };

    this.moveItemToLastPosition = function(item) {
        if(item) {
            var index = this.selectedAddressFields.indexOf(item);
            if(index > -1) {
                this.selectedAddressFields.move(index, this.selectedAddressFields.length - 1)
            }
        }
    };

    this.moveItemDown = function(item) {
        if(item) {
            var index = this.selectedAddressFields.indexOf(item);
            if(index > -1 && index > 0) {
                this.selectedAddressFields.move(index - 1, index)
            }
        }
    };

    this.moveItemUp = function(item) {
        if(item) {
            var index = this.selectedAddressFields.indexOf(item);
            if(index > -1 && index < this.selectedAddressFields.length - 1) {
                this.selectedAddressFields.move(index + 1, index)
            }
        }
    };
}